import {ControlledInput} from '@hm/fundamental'
import React from 'react'
import {Controller, useFormContext} from 'react-hook-form'

import {useTranslation} from '../../../hooks/useTranslation'
import {GroupedRoleAssignment} from '../../../modules/ManageUsers.selectors'
import {checkRequired} from '../utils'

type ReadonlyDataScopeProps = {
  isRequired: boolean
  errorMessage: string
  dataScopeName: string
  multiSelect: boolean
}

export const ReadonlyDataScope = ({
  isRequired,
  dataScopeName,
  multiSelect,
  errorMessage
}: ReadonlyDataScopeProps) => {
  const {control, getValues} = useFormContext<GroupedRoleAssignment>()

  const {t} = useTranslation()
  const fieldName = `commonDataScopes.${dataScopeName}`

  return (
    <Controller
      key={dataScopeName}
      rules={{
        validate: checkRequired(
          isRequired,
          multiSelect,
          t('roleAssignment.dataScopeRequired', {
            dataScope: t(`roleAssignment.dataScope.${dataScopeName}`)
          })
        )
      }}
      name={fieldName as keyof GroupedRoleAssignment}
      control={control}
      render={({field}) => (
        <ControlledInput
          {...field}
          label={t(`roleAssignment.dataScope.${dataScopeName}`)}
          value={(getValues().commonDataScopes[dataScopeName] as string) || ''}
          isDisabled={true}
          required={isRequired}
          error={errorMessage}
        />
      )}
    />
  )
}
